import { IActionCreatorAsync } from "core/actions/Actions.interfaces";
import { ILicense } from "reducers/Reducers.interfaces";
import { IlicenseCard } from "../Tenant.types";

export interface licenseFormProps {
  dataSource:Array<IlicenseCard>
  title: any
  onCancelClick: (id:string | null, data: any)=>void
  updateLicenseByApp: IActionCreatorAsync
  createLicenseAllocationUpdateEvent: IActionCreatorAsync
  context: string
  id: any
  license?: ILicense
  app_code: string
  partnerAccountId?: string
  type: string
  licenseFeatureVersion?: LicenseFeatureVersion
  showToggle?: boolean
  fairUsage?: IStmFairUsage | null
  stmPackageCode?: string
}

export interface IStmFairUsageRatio {
  ratio_units: number
  ratio_per_signatures: number
  cap?: number
}

export interface IStmFairUsageBand {
  min_signatures: number
  max_signatures: number | null
  value: number
}

export interface IStmFairUsage {
  signature_minimum?: number
  repositories?: IStmFairUsageRatio
  test_signatures?: IStmFairUsageRatio
  hsm_keypairs?: { bands: IStmFairUsageBand[] }
}

export enum LicenseFormActions {
  NO_CHANGE = 'no-change',
  ADD = 'add',
  SUBTRACT = 'subtract',
  RESET = 'reset'
}

export enum LicenseFeatureVersion {
  V1 = 'v1',
  V2 = 'v2',
  V2_5 = 'v2.5',
  V2_6 = 'v2.6'
}